/* LEDPLANET lp-levertijd.js (17-10-2026): rekenlogica van de centrale levertijd (uit snippets/ledplanet-levertijd), als gecacht bestand.
   De data (metaobjecten, product, markt) staat inline in window.LP_LEVERTIJD_DATA; dit bestand wordt direct daarna synchroon geladen
   (zelfde volgorde als voorheen: delivery-label.js en de productscripts gebruiken window.LP_LEVERTIJD meteen). Wijzig de logica HIER.
   02-11-2026: PostNL-drukte (Sinterklaas, Black Friday, kerst): vinkje in Levertijd instellingen. Aan = bij alle profielen met vervoerder
   PostNL komen er extra werkdagen bij de bezorgdag (veld 'extra werkdagen', leeg = 1), ook in het buitenland en bij een vaste levertijd
   in werkdagen. De tooltip krijgt een korte uitleg in de taal van de pagina (NL: eigen tekst uit het veld als die is ingevuld). */
(function () {
  var D = window.LP_LEVERTIJD_DATA;
  if (!D) return;

  // ---- Taal van de pagina (nl, de, en, fr, es, it, pl) ----
  var TAAL = ((document.documentElement.lang || 'nl').slice(0, 2)).toLowerCase();
  var T = {
    nl: { tipVast: 'Je bestelling wordt {dag} geleverd{met}.', morgen: 'Nu bestellen = morgen je {lv} in huis{met}', vandaag: 'Voor {t} besteld = {dag} je {lv} in huis{met}', later: 'Voor 23:59 besteld = {dag} je {lv} ontvangen{met}',
          tipMorgen: 'Bestel voor {t} uur en ontvang je bestelling morgen{met}.', tipVandaag: 'Bestel voor {t} uur, dan wordt je bestelling vandaag verzonden en {dag} geleverd{met}.',
          tipLater: 'Je bestelling wordt {vdag} verzonden en {dag} geleverd{met}.', tipReden: 'Vanwege {reden} wordt je bestelling {vdag} verzonden en {dag} geleverd{met}.',
          feest: 'een feestdag', tipDicht: 'Tijdelijk geen verzending: je bestelling wordt {vdag} verzonden en {dag} geleverd{met}.', met: ' met {v}', levertijd: 'Levertijd: {x}', kaart: '{d} in huis',
          beginVandaag: 'Voor {t} besteld = vandaag verzonden', beginLater: 'Nu besteld = {vdag} verzonden', buitenland: '{begin}, verwacht {venster} in {land}{met}',
          tipLand: 'Bezorging naar {land} duurt meestal {min} - {max} werkdagen na verzending{met}.', tipLandVast: 'Naar {land} kan de bezorging enkele werkdagen langer duren.',
          tipDrukte: 'Vanwege de drukte bij {v} duurt de bezorging nu iets langer.',
          heute: 'vandaag', morgenW: 'morgen', bestelling: 'bestelling' },
    de: { tipVast: 'Deine Bestellung wird {dag} geliefert{met}.', morgen: 'Jetzt bestellen = morgen geliefert{met}', vandaag: 'Vor {t} Uhr bestellt = {dag} geliefert{met}', later: 'Jetzt bestellen = {dag} geliefert{met}',
          tipMorgen: 'Bestelle vor {t} Uhr und erhalte deine Bestellung morgen{met}.', tipVandaag: 'Vor {t} Uhr bestellt: heute versendet und {dag} geliefert{met}.',
          tipLater: 'Deine Bestellung wird {vdag} versendet und {dag} geliefert{met}.', tipReden: 'Wegen {reden} wird deine Bestellung {vdag} versendet und {dag} geliefert{met}.',
          feest: 'eines Feiertags', tipDicht: 'Vorübergehend kein Versand: Deine Bestellung wird {vdag} versendet und {dag} geliefert{met}.', met: ' mit {v}', levertijd: 'Lieferzeit: {x}', kaart: 'Lieferung {d}',
          beginVandaag: 'Vor {t} Uhr bestellt = heute versendet', beginLater: 'Jetzt bestellt = {vdag} versendet', buitenland: '{begin}, voraussichtlich {venster} ({land}){met}',
          tipLand: 'Die Lieferung nach {land} dauert meist {min} - {max} Werktage nach Versand{met}.', tipLandVast: 'Die Lieferung nach {land} kann einige Werktage länger dauern.',
          tipDrukte: 'Wegen des hohen Paketaufkommens bei {v} dauert die Zustellung derzeit etwas länger.',
          heute: 'heute', morgenW: 'morgen' },
    en: { tipVast: 'Your order will be delivered {dag}{met}.', morgen: 'Order now = delivered tomorrow{met}', vandaag: 'Order before {t} = delivered {dag}{met}', later: 'Order now = delivered {dag}{met}',
          tipMorgen: 'Order before {t} and receive your order tomorrow{met}.', tipVandaag: 'Order before {t}: shipped today and delivered {dag}{met}.',
          tipLater: 'Your order will be shipped {vdag} and delivered {dag}{met}.', tipReden: 'Due to {reden}, your order will be shipped {vdag} and delivered {dag}{met}.',
          feest: 'a public holiday', tipDicht: 'Temporarily no shipping: your order will be shipped {vdag} and delivered {dag}{met}.', met: ' with {v}', levertijd: 'Delivery time: {x}', kaart: 'Delivered {d}',
          beginVandaag: 'Order before {t} = shipped today', beginLater: 'Order now = shipped {vdag}', buitenland: '{begin}, expected {venster} ({land}){met}',
          tipLand: 'Delivery to {land} usually takes {min} - {max} working days after shipping{met}.', tipLandVast: 'Delivery to {land} may take a few extra working days.',
          tipDrukte: 'Due to high parcel volumes at {v}, delivery currently takes a little longer.',
          heute: 'today', morgenW: 'tomorrow' },
    fr: { tipVast: 'Votre commande sera livrée {dag}{met}.', morgen: 'Commandez maintenant = livré demain{met}', vandaag: 'Commandé avant {t} = livré {dag}{met}', later: 'Commandez maintenant = livré {dag}{met}',
          tipMorgen: 'Commandez avant {t} et recevez votre commande demain{met}.', tipVandaag: 'Commandé avant {t} : expédié aujourd’hui et livré {dag}{met}.',
          tipLater: 'Votre commande sera expédiée {vdag} et livrée {dag}{met}.', tipReden: 'En raison {reden}, votre commande sera expédiée {vdag} et livrée {dag}{met}.',
          feest: 'd’un jour férié', tipDicht: 'Pas d’expédition temporairement : votre commande sera expédiée {vdag} et livrée {dag}{met}.', met: ' avec {v}', levertijd: 'Délai de livraison : {x}', kaart: 'Livré {d}',
          beginVandaag: 'Commandé avant {t} = expédié aujourd’hui', beginLater: 'Commandé maintenant = expédié {vdag}', buitenland: '{begin}, livraison prévue {venster} ({land}){met}',
          tipLand: 'La livraison ({land}) prend généralement {min} à {max} jours ouvrés après l’expédition{met}.', tipLandVast: 'La livraison ({land}) peut prendre quelques jours ouvrés de plus.',
          tipDrukte: 'En raison du grand nombre de colis chez {v}, la livraison prend actuellement un peu plus de temps.',
          heute: 'aujourd’hui', morgenW: 'demain' },
    es: { tipVast: 'Tu pedido se entregará: {dag}{met}.', morgen: 'Pide ahora = entrega mañana{met}', vandaag: 'Pide antes de las {t} = entrega: {dag}{met}', later: 'Pide ahora = entrega: {dag}{met}',
          tipMorgen: 'Pide antes de las {t} y recibe tu pedido mañana{met}.', tipVandaag: 'Pedido antes de las {t}: enviado hoy, entrega: {dag}{met}.',
          tipLater: 'Tu pedido se enviará: {vdag}, entrega: {dag}{met}.', tipReden: 'Debido a {reden}, tu pedido se enviará: {vdag}, entrega: {dag}{met}.',
          feest: 'un día festivo', tipDicht: 'Envíos pausados temporalmente: tu pedido se enviará: {vdag}, entrega: {dag}{met}.', met: ' con {v}', levertijd: 'Plazo de entrega: {x}', kaart: 'Entrega: {d}',
          beginVandaag: 'Pedido antes de las {t} = enviado hoy', beginLater: 'Pedido ahora = envío: {vdag}', buitenland: '{begin}, entrega prevista: {venster} ({land}){met}',
          tipLand: 'La entrega a {land} suele tardar {min} - {max} días laborables tras el envío{met}.', tipLandVast: 'La entrega a {land} puede tardar unos días laborables más.',
          tipDrukte: 'Debido al gran volumen de paquetes en {v}, la entrega tarda ahora un poco más.',
          heute: 'hoy', morgenW: 'mañana' },
    it: { tipVast: 'Il tuo ordine sarà consegnato: {dag}{met}.', morgen: 'Ordina ora = consegna domani{met}', vandaag: 'Ordina entro le {t} = consegna: {dag}{met}', later: 'Ordina ora = consegna: {dag}{met}',
          tipMorgen: 'Ordina entro le {t} e ricevi il tuo ordine domani{met}.', tipVandaag: 'Ordine entro le {t}: spedito oggi, consegna: {dag}{met}.',
          tipLater: 'Il tuo ordine sarà spedito: {vdag}, consegna: {dag}{met}.', tipReden: 'A causa di {reden}, il tuo ordine sarà spedito: {vdag}, consegna: {dag}{met}.',
          feest: 'un giorno festivo', tipDicht: 'Spedizioni temporaneamente sospese: il tuo ordine sarà spedito: {vdag}, consegna: {dag}{met}.', met: ' con {v}', levertijd: 'Tempi di consegna: {x}', kaart: 'Consegna: {d}',
          beginVandaag: 'Ordine entro le {t} = spedito oggi', beginLater: 'Ordine ora = spedizione: {vdag}', buitenland: '{begin}, consegna prevista: {venster} ({land}){met}',
          tipLand: 'La consegna in {land} richiede di solito {min} - {max} giorni lavorativi dalla spedizione{met}.', tipLandVast: 'La consegna in {land} può richiedere alcuni giorni lavorativi in più.',
          tipDrukte: 'A causa dell’elevato numero di pacchi presso {v}, la consegna richiede al momento un po’ più di tempo.',
          heute: 'oggi', morgenW: 'domani' },
    pl: { tipVast: 'Twoje zamówienie zostanie dostarczone: {dag}{met}.', morgen: 'Zamów teraz = dostawa jutro{met}', vandaag: 'Zamów do {t} = dostawa: {dag}{met}', later: 'Zamów teraz = dostawa: {dag}{met}',
          tipMorgen: 'Zamów do {t}, a otrzymasz zamówienie jutro{met}.', tipVandaag: 'Zamówienie do {t}: wysyłka dziś, dostawa: {dag}{met}.',
          tipLater: 'Twoje zamówienie zostanie wysłane: {vdag}, dostawa: {dag}{met}.', tipReden: 'Z powodu {reden} zamówienie zostanie wysłane: {vdag}, dostawa: {dag}{met}.',
          feest: 'święta', tipDicht: 'Wysyłka chwilowo wstrzymana: zamówienie zostanie wysłane: {vdag}, dostawa: {dag}{met}.', met: ' przez {v}', levertijd: 'Czas dostawy: {x}', kaart: 'Dostawa: {d}',
          beginVandaag: 'Zamówienie do {t} = wysyłka dziś', beginLater: 'Zamówienie teraz = wysyłka: {vdag}', buitenland: '{begin}, przewidywana dostawa: {venster} ({land}){met}',
          tipLand: 'Dostawa ({land}) trwa zwykle {min} - {max} dni roboczych od wysyłki{met}.', tipLandVast: 'Dostawa ({land}) może potrwać kilka dni roboczych dłużej.',
          tipDrukte: 'Z powodu dużej liczby przesyłek w {v} dostawa trwa obecnie nieco dłużej.',
          heute: 'dziś', morgenW: 'jutro' }
  };
  if (!T[TAAL]) TAAL = 'en';
  var L = T[TAAL];
  function f(s, o) { return s.replace(/\{(\w+)\}/g, function (m, k) { return o[k] !== undefined ? o[k] : ''; }); }
  function fmt(d, opt) { opt.timeZone = 'UTC'; try { return new Intl.DateTimeFormat(TAAL === 'en' ? 'en-GB' : TAAL, opt).format(d); } catch (e) { return d.toISOString().slice(0, 10); } }
  function landNaam(l) {
    if (TAAL === 'nl' && l.naam) return l.naam;
    try { return new Intl.DisplayNames([TAAL], { type: 'region' }).of(l.code); } catch (e) { return l.naam || l.code; }
  }

  // ---- Land van de bezoeker en tijd van de Shopify-server (bewaard per sessie) ----
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  var params = null;
  try { params = new URLSearchParams(location.search); } catch (e) {}
  var TESTLAND = params && params.get('lp_land');
  function keus(v) { try { if (v === undefined) return localStorage.getItem('lp_land_keus'); localStorage.setItem('lp_land_keus', v); } catch (e) { return null; } }
  var KEUS = keus();
  // 17-10-2026: bezoekt iemand de winkel voor een ander land (Shopify-markt, bv. /de-de/ of ?country=BE), dan gaat dat land voor op de IP-herkenning
  var MARKT = D.markt || 'NL';   // markt van de pagina (Liquid: localization.country) staat in LP_LEVERTIJD_DATA.markt
  var MARKTLAND = MARKT && MARKT !== 'NL' ? MARKT : null;
  var LAND = (TESTLAND || KEUS || MARKTLAND || ss('lp_land') || '').toUpperCase() || null;
  var OFFSET = parseInt(ss('lp_offset'), 10) || 0;

  // ---- Tijd in Nederland (niet de klok van de bezoeker) ----
  function nu() {
    var test = params && params.get('lp_now');
    var m = test && test.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (m) return { datum: dag(+m[1], +m[2], +m[3]), minuten: (+m[4]) * 60 + (+m[5]) };
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date(Date.now() + OFFSET)).forEach(function (x) { p[x.type] = x.value; });
    return { datum: dag(+p.year, +p.month, +p.day), minuten: (+p.hour) * 60 + (+p.minute) };
  }
  function dag(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function plus(d, n) { return new Date(d.getTime() + n * 864e5); }
  function sleutel(d) { return d.toISOString().slice(0, 10); }
  function verschil(a, b) { return Math.round((b - a) / 864e5); }
  function landInfo() {
    if (!LAND || LAND === 'NL') return null;
    var LL = D.landen || [];
    for (var i = 0; i < LL.length; i++) if (LL[i].code === LAND) return LL[i];
    return null;
  }
  // Vaste levertijd (alles gaat vanuit NL): buiten NL de extra bezorgdagen van dat land erbij.
  // '1 - 3' wordt min-1 en max-1 hoger, bijv. Duitsland (2-3) -> '2 - 5', Italie (4-6) -> '4 - 8'. Alleen het eerste bereik in de tekst.
  function schuif(s, li) {
    if (!s || !li) return s;
    return String(s).replace(/(\d{1,2})(\s*[–-]\s*)(\d{1,2})/, function (m, a, sep, b) { return (+a + li.min - 1) + sep + (+b + li.max - 1); });
  }
  // werkdagen na verzending; feestdagen van het bestemmingsland tellen niet mee (17-10-2026)
  function werkdagenNa(d, n, code) { var x = d; for (var i = 0; n > 0 && i < 90; i++) { x = plus(x, 1); var w = x.getUTCDay(); if (w >= 1 && w <= 5 && !feestIn(code, x)) n--; } return x; }

  // ---- PostNL-drukte (02-11-2026): extra werkdagen voor profielen met vervoerder PostNL, alleen als het vinkje aan staat ----
  function drukte(p) {
    var Dr = D.postnlDrukte;
    if (!p || !Dr || !Dr.aan || !/postnl/i.test(p.vervoerder || '')) return 0;
    var n = parseInt(Dr.dagen, 10);
    if (isNaN(n)) n = 1;
    return Math.max(0, Math.min(n, 10));
  }
  function drukteTip(p) {
    if (!drukte(p)) return '';
    var eigen = D.postnlDrukte && D.postnlDrukte.melding;
    return (TAAL === 'nl' && eigen) ? eigen : f(L.tipDrukte, { v: p.vervoerder || 'PostNL' });
  }

  // ---- Sluitingen uitvouwen naar losse dagen ----
  var FEEST = {}, EIGEN = {};
  (D.sluitingen || []).forEach(function (s) {
    if (!s.van) return;
    var a = new Date(s.van + 'T00:00:00Z'), b = new Date((s.tot || s.van) + 'T00:00:00Z');
    for (var d = a, i = 0; d <= b && i < 400; d = plus(d, 1), i++) {
      (s.feestdag ? FEEST : EIGEN)[sleutel(d)] = String(s.omschrijving || '').replace(/\s*\d{4}\s*$/, ''); // jaartal niet tonen
    }
  });
  // ---- Feestdagen in het bestemmingsland (geen bezorging daar), 17-10-2026. NL komt uit de metaobjecten hierboven. ----
  var FEEST_LAND = {
    BE: '2026-01-01 2026-04-06 2026-05-01 2026-05-14 2026-05-25 2026-07-21 2026-08-15 2026-11-01 2026-11-11 2026-12-25 2027-01-01 2027-03-29 2027-05-01 2027-05-06 2027-05-17 2027-07-21 2027-08-15 2027-11-01 2027-11-11 2027-12-25',
    DE: '2026-01-01 2026-04-03 2026-04-06 2026-05-01 2026-05-14 2026-05-25 2026-10-03 2026-12-25 2026-12-26 2027-01-01 2027-03-26 2027-03-29 2027-05-01 2027-05-06 2027-05-17 2027-10-03 2027-12-25 2027-12-26'
  };
  function feestIn(code, d) {
    var k = sleutel(d);
    if (!code || code === 'NL') return !!FEEST[k];
    return (' ' + (FEEST_LAND[code] || '') + ' ').indexOf(' ' + k + ' ') > -1;
  }

  // ---- Profiel kiezen: product-metaveld > bol-levertijdcode > leverancier > template > standaard ----
  function lijst(x) { return Array.isArray(x) ? x : []; }
  function profielVoor(info) {
    var P = D.profielen || [], i;
    info = info || {};
    if (info.profiel) for (i = 0; i < P.length; i++) if (P[i].handle === info.profiel) return P[i];
    var b = (info.bol || '').toUpperCase().trim();
    if (b) for (i = 0; i < P.length; i++) {
      if (lijst(P[i].bolCodes).some(function (x) { return x.toUpperCase().trim() === b; })) return P[i];
    }
    var v = (info.vendor || '').toLowerCase().trim();
    if (v) for (i = 0; i < P.length; i++) {
      if (lijst(P[i].leveranciers).some(function (x) { return x.toLowerCase().trim() === v; })) return P[i];
    }
    if (info.template) for (i = 0; i < P.length; i++) if (lijst(P[i].templates).indexOf(info.template) > -1) return P[i];
    for (i = 0; i < P.length; i++) if (P[i].standaard) return P[i];
    return P[0] || null;
  }

  // ---- Vaste leverdag: aan/uit + dag (dropdown) of datum, alleen voor eigen voorraad (bol-code VVB) ----
  var DAGEN = { zondag: 0, maandag: 1, dinsdag: 2, woensdag: 3, donderdag: 4, vrijdag: 5, zaterdag: 6 };
  function isEigenVoorraad(p) {
    return lijst(p.bolCodes).some(function (x) { return String(x).toUpperCase().trim() === 'VVB'; });
  }
  function vasteBezorgdag(p, vandaag) {
    var V = D.vasteDag;
    if (!V || !V.aan || p.vast || !isEigenVoorraad(p)) return null;
    if (V.datum) {
      var d = new Date(V.datum + 'T00:00:00Z');
      if (!isNaN(d) && d > vandaag) return d;           // datum in het verleden of vandaag: negeren
    }
    var naam = String(V.dag || '').toLowerCase().trim();
    if (naam === 'morgen') {                              // eerstvolgende bezorgdag: geen zondag/feestdag (zaterdag alleen als het profiel dat doet)
      var m = plus(vandaag, 1);
      for (var j = 0; j < 14; j++) {
        var w = m.getUTCDay();
        if (w !== 0 && (w !== 6 || p.zaterdag) && !FEEST[sleutel(m)]) break;
        m = plus(m, 1);
      }
      return m;
    }
    if (naam in DAGEN) {
      var x = plus(vandaag, 1);
      for (var i = 0; i < 7 && x.getUTCDay() !== DAGEN[naam]; i++) x = plus(x, 1);
      return x;                                          // eerstvolgende keer dat die dag valt (nooit vandaag)
    }
    return null;                                         // aan, maar niets gekozen: automatisch blijven rekenen
  }

  // ---- Kern: verzend- en bezorgdag berekenen ----
  function bereken(p) {
    var t = nu(), vandaag = t.datum;
    var cut = (p.besteltijd || '15:00').split(':');
    var cutMin = (+cut[0]) * 60 + (+(cut[1] || 0));

    function reden(d) {
      var k = sleutel(d);
      if (FEEST[k]) return { tekst: FEEST[k], feest: true };
      if (p.volgtSluitingen && EIGEN[k]) return { tekst: EIGEN[k], feest: false };
      if (p.volgtSluitingen && D.nuGesloten && k === sleutel(vandaag)) return { tekst: '', feest: false, nu: true };
      return null;
    }
    function verzenddag(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !reden(d); }
    var zat = p.zaterdag && !/dpd/i.test(p.vervoerder || '');   // DPD bezorgt niet op zaterdag (17-10-2026)
    function bezorgdag(d) { var w = d.getUTCDay(); return w !== 0 && (w !== 6 || zat) && !FEEST[sleutel(d)]; }

    var verzend = vandaag, sluitReden = null;
    if (!(verzenddag(vandaag) && t.minuten < cutMin)) {
      sluitReden = reden(vandaag);
      verzend = plus(vandaag, 1);
      for (var i = 0; i < 60 && !verzenddag(verzend); i++) { sluitReden = sluitReden || reden(verzend); verzend = plus(verzend, 1); }
    }
    var bezorg = plus(verzend, 1);
    for (var j = 0; j < 30 && !bezorgdag(bezorg); j++) bezorg = plus(bezorg, 1);

    // ---- PostNL-drukte (02-11-2026): bezorgdag X bezorgdagen later ----
    var extra = drukte(p);
    for (var e = 0; e < extra; e++) {
      bezorg = plus(bezorg, 1);
      for (var j2 = 0; j2 < 30 && !bezorgdag(bezorg); j2++) bezorg = plus(bezorg, 1);
    }

    // ---- Vaste leverdag (Levertijd instellingen): alleen eigen voorraad / VVB ----
    var vast = vasteBezorgdag(p, vandaag);
    if (vast) {
      bezorg = vast;
      // verzenddag = werkdag voor de bezorgdag, maar niet voor vandaag
      verzend = plus(bezorg, -1);
      for (var k = 0; k < 10 && verzend > vandaag && (verzend.getUTCDay() === 0 || verzend.getUTCDay() === 6); k++) verzend = plus(verzend, -1);
      if (verzend < vandaag) verzend = vandaag;
      sluitReden = null;
      extra = 0;
    }

    var land = landInfo();
    return {
      land: land,
      landVan: land ? werkdagenNa(verzend, land.min + extra, land.code) : null,
      landTot: land ? werkdagenNa(verzend, land.max + extra, land.code) : null,
      minuten: (verzend.getTime() === vandaag.getTime() && !vast) ? cutMin - t.minuten : null,
      vandaag: vandaag, verzend: verzend, bezorg: bezorg, reden: sluitReden, vast: !!vast, drukte: extra,
      vandaagVerzonden: sleutel(verzend) === sleutel(vandaag),
      morgen: verschil(vandaag, bezorg) === 1,
      besteltijd: (p.besteltijd || '15:00')
    };
  }

  function dagNaam(r, d) {
    var n = verschil(r.vandaag, d);
    if (n === 0) return L.heute;
    if (n === 1) return L.morgenW;
    if (n <= 6) return fmt(d, { weekday: 'long' });
    return fmt(d, { weekday: 'long', day: 'numeric', month: 'long' });
  }
  function kortNaam(r, d) {
    var n = verschil(r.vandaag, d);
    if (n <= 6) return fmt(d, { weekday: 'short' }).replace('.', '');
    return fmt(d, { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
  }
  function hoofd(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function lang(d) { return fmt(d, { weekday: 'long', day: 'numeric', month: 'long' }); }
  function kort(d) { return fmt(d, { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); }
  // Twee dagen (buitenland): valt de laatste verder dan 6 dagen weg, dan beide met datum
  function paar(r, a, b, isKort) {
    var ver = verschil(r.vandaag, b) > 6;
    var x = ver ? (isKort ? kort(a) : lang(a)) : (isKort ? kortNaam(r, a) : dagNaam(r, a));
    var y = ver ? (isKort ? kort(b) : lang(b)) : (isKort ? kortNaam(r, b) : dagNaam(r, b));
    if (isKort) { x = hoofd(x); y = hoofd(y); }
    return x === y ? x : x + ' - ' + y;
  }
  // Feestdag: naam van de feestdag (vertaald via Shopify > Talen). Eigen dag zonder verzending: neutrale tekst, de omschrijving blijft intern.
  function redenTekst(r) {
    if (!r.reden || !r.reden.feest) return null;
    var naam = r.reden.tekst || '';
    if (TAAL === 'nl') return naam || L.feest;
    return naam ? L.feest + ' (' + naam + ')' : L.feest;
  }
  function tipReden(r, rt, vdag, dag, met) {
    if (rt) return f(L.tipReden, { reden: rt, vdag: vdag, dag: dag, met: met });
    return f(L.tipDicht, { vdag: vdag, dag: dag, met: met });
  }

  // ---- Echte bezorgdatum (17-10-2026) ----
  var T2 = {
    nl: { morgen: 'morgen in huis', inHuis: '{d} in huis', verwacht: 'verwacht {d} in huis', uiterlijk: 'uiterlijk {d}', binnen: 'Bestel binnen {x}', u: '{u} u {m} min', m: '{m} min', verzending: 'verzending met {v}' },
    de: { morgen: 'Lieferung morgen', inHuis: 'Lieferung {d}', verwacht: 'voraussichtliche Lieferung {d}', uiterlijk: 'spätestens {d}', binnen: 'Bestelle innerhalb von {x}', u: '{u} Std. {m} Min.', m: '{m} Min.', verzending: 'Versand mit {v}' },
    en: { morgen: 'delivered tomorrow', inHuis: 'delivered {d}', verwacht: 'expected delivery {d}', uiterlijk: 'at the latest {d}', binnen: 'Order within {x}', u: '{u} h {m} min', m: '{m} min', verzending: 'shipped with {v}' },
    fr: { morgen: 'livré demain', inHuis: 'livré {d}', verwacht: 'livraison prévue {d}', uiterlijk: 'au plus tard {d}', binnen: 'Commandez dans les {x}', u: '{u} h {m} min', m: '{m} min', verzending: 'expédié avec {v}' },
    es: { morgen: 'entrega mañana', inHuis: 'entrega el {d}', verwacht: 'entrega prevista el {d}', uiterlijk: 'como muy tarde el {d}', binnen: 'Pide en las próximas {x}', u: '{u} h {m} min', m: '{m} min', verzending: 'envío con {v}' },
    it: { morgen: 'consegna domani', inHuis: 'consegna {d}', verwacht: 'consegna prevista {d}', uiterlijk: 'al più tardi {d}', binnen: 'Ordina entro {x}', u: '{u} h {m} min', m: '{m} min', verzending: 'spedizione con {v}' },
    pl: { morgen: 'dostawa jutro', inHuis: 'dostawa {d}', verwacht: 'przewidywana dostawa {d}', uiterlijk: 'najpóźniej {d}', binnen: 'Zamów w ciągu {x}', u: '{u} godz. {m} min', m: '{m} min', verzending: 'wysyłka {v}' }
  };
  var L2 = T2[TAAL] || T2.en;
  // eerste en laatste bezorgdag voor een profiel; null = geen datum te geven (bv. 'levertijd 2 weken')
  function datum(p) {
    if (!p) return null;
    var r = bereken(p), van, tot;
    if (p.vast) {
      // werkdagen in elke taal ('1 - 3 werkdagen', '1 à 3 jours ouvrés', '1 bis 3 Werktage', 'da 1 a 3 giorni lavorativi'): eerste twee getallen
      if (!/(werkdag|werktag|working day|business day|jours? ouvr|d[ií]as? (h[aá]bil|laborabl)|giorni lav|dni rob)/i.test(String(p.vast))) return null;
      var m = String(p.vast).match(/\d{1,2}/g);
      if (!m) return null;
      var a = +m[0], b = (m[1] && +m[1] >= a) ? +m[1] : a;
      if (r.land) { a += r.land.min - 1; b += r.land.max - 1; }
      var ex = drukte(p); a += ex; b += ex;              // PostNL-drukte (02-11-2026)
      var code = r.land ? r.land.code : 'NL';
      van = werkdagenNa(r.verzend, a, code); tot = werkdagenNa(r.verzend, b, code);
    } else if (r.land) { van = r.landVan; tot = r.landTot; }
    else { van = r.bezorg; tot = r.bezorg; }
    return { van: van, tot: tot, bereik: van.getTime() !== tot.getTime(), vandaag: r.vandaag, minuten: r.minuten > 0 ? r.minuten : null, vervoerder: p.vervoerder || '', land: r.land };
  }
  function duur(min) { var u = Math.floor(min / 60), m = min % 60; return u > 0 ? f(L2.u, { u: u, m: m }).replace(/\s0\s\S+$/, '') : f(L2.m, { m: Math.max(1, m) }); }
  // zin voor de productpagina: { tekst: 'Bestel binnen 2 u 14 min, maandag 19 oktober in huis', klein: '(uiterlijk ...)' }
  function regel(p, aftellen) {
    var dt = datum(p); if (!dt) return null;
    var deel, klein = '';
    if (dt.bereik) { deel = f(L2.verwacht, { d: lang(dt.van) }); klein = '(' + f(L2.uiterlijk, { d: lang(dt.tot) }) + ')'; }
    else deel = verschil(dt.vandaag, dt.van) === 1 ? L2.morgen : f(L2.inHuis, { d: lang(dt.van) });
    var tekst = (aftellen !== false && dt.minuten) ? f(L2.binnen, { x: duur(dt.minuten) }) + ', ' + deel : hoofd(deel);
    return { tekst: tekst, klein: klein, minuten: dt.minuten, vervoerder: dt.vervoerder, verzending: dt.vervoerder ? f(L2.verzending, { v: dt.vervoerder }) : '', met: dt.vervoerder ? f(L.met, { v: dt.vervoerder }) : '', drukte: drukteTip(p) };
  }
  // kort voor kaarten: 'Morgen in huis', 'Ma 19 okt in huis', 'Di 20 – do 22 okt'
  function kaartDatum(dt) {
    if (!dt.bereik) return hoofd(f(L.kaart, { d: verschil(dt.vandaag, dt.van) === 1 ? L.morgenW : kort(dt.van).replace(/,/g, '') }));
    var zelfde = dt.van.getUTCMonth() === dt.tot.getUTCMonth();
    var a = zelfde ? fmt(dt.van, { weekday: 'short', day: 'numeric' }).replace(/\./g, '') : kort(dt.van);
    return hoofd((a + ' – ' + kort(dt.tot)).replace(/,/g, ''));
  }

  // ---- Tekst voor productpagina ----
  function metDrukte(p, uit) {                            // PostNL-drukte: uitleg vooraan in de tooltip (02-11-2026)
    var dt = drukteTip(p);
    if (dt) uit.tooltip = dt + (uit.tooltip ? ' ' + uit.tooltip : '');
    return uit;
  }
  function productTekst(p, lv) {
    lv = (TAAL === 'nl' && lv) ? lv : (L.bestelling || '');
    var met = p.vervoerder ? f(L.met, { v: p.vervoerder }) : '';
    if (p.vast) {
      var li = landInfo();
      var vast = li ? schuif(p.vast, li) : p.vast;             // buitenland: vaste levertijd + extra bezorgdagen van dat land
      var tekst = /^\d/.test(vast) ? f(L.levertijd, { x: vast }) + met : vast;
      var tip = li ? schuif(p.toelichting || '', li) : (p.toelichting || '');
      if (li && vast === p.vast) tip = (tip ? tip + ' ' : '') + f(L.tipLandVast, { land: landNaam(li) });
      var rg = regel(p, false);                               // 17-10-2026: echte datum i.p.v. 'Levertijd: 1 - 3 werkdagen'
      if (rg) tekst = rg.tekst + (rg.klein ? ' ' + rg.klein : '') + met;
      return metDrukte(p, { text: tekst, tooltip: tip });
    }
    var r = bereken(p);
    var o = { lv: lv, met: met, t: r.besteltijd, dag: dagNaam(r, r.bezorg), vdag: dagNaam(r, r.verzend) };
    var rt = redenTekst(r);
    if (r.land) {
      o.venster = paar(r, r.landVan, r.landTot, false);
      o.land = landNaam(r.land); o.min = r.land.min + r.drukte; o.max = r.land.max + r.drukte;
      o.begin = f(r.vandaagVerzonden ? L.beginVandaag : L.beginLater, o);
      var tipL = f(L.tipLand, o);
      if (r.reden) tipL = tipReden(r, rt, o.vdag, o.venster, '') + ' ' + tipL;
      return metDrukte(p, { text: f(L.buitenland, o), tooltip: tipL });
    }
    if (r.vast) return { text: f(L.later, o), tooltip: f(L.tipVast, o) };
    if (r.vandaagVerzonden && r.morgen) return metDrukte(p, { text: f(L.morgen, o), tooltip: f(L.tipMorgen, o) });
    if (r.vandaagVerzonden) return metDrukte(p, { text: f(L.vandaag, o), tooltip: f(L.tipVandaag, o) });
    var tooltip = r.reden ? tipReden(r, rt, o.vdag, o.dag, met) : f(L.tipLater, o);
    if (r.reden && r.reden.nu && D.melding && TAAL === 'nl') tooltip = D.melding + ' ' + tooltip;
    return metDrukte(p, { text: f(L.later, o), tooltip: tooltip });
  }

  // ---- Label voor productkaart ----
  function kaartTekst(info) {
    var p = profielVoor(info);
    if (!p || p.kaartVerbergen) return null;
    // 17-10-2026: echte datum (ook bij vaste levertijd met kaartlabel); geen datum mogelijk = oude tekst
    var dt = (!p.vast || p.kaartLabel) ? datum(p) : null;
    if (dt) return kaartDatum(dt);
    if (p.vast) { var li = landInfo(); return p.kaartLabel ? (li ? schuif(p.kaartLabel, li) : p.kaartLabel) : null; }
    var r = bereken(p);
    if (r.land) {
      return f(L.kaart, { d: paar(r, r.landVan, r.landTot, true) });
    }
    var n = verschil(r.vandaag, r.bezorg);
    var d = n <= 1 ? dagNaam(r, r.bezorg) : (n <= 6 ? dagNaam(r, r.bezorg) : kortNaam(r, r.bezorg));
    return hoofd(f(L.kaart, { d: d }));
  }

  window.LP_LEVERTIJD = {
    profielVoor: profielVoor,
    bereken: bereken,
    productTekst: function (lv) { var p = profielVoor(D.product); return p ? productTekst(p, lv) : null; },
    kaartTekst: kaartTekst,
    profiel: function () { return profielVoor(D.product); },
    datum: function (info) { return datum(info && info.naam !== undefined ? info : profielVoor(info || D.product)); },
    productRegel: function (aftellen) { return D.product ? regel(profielVoor(D.product), aftellen) : null; },
    drukte: function (info) { var p = info && info.naam !== undefined ? info : profielVoor(info || D.product); return { dagen: drukte(p), tekst: drukteTip(p) }; },
    taal: TAAL,
    land: function () { return LAND || 'NL'; },
    landen: function () { return D.landen || []; },
    zetLand: function (code) { code = String(code || 'NL').toUpperCase(); LAND = code; KEUS = code; keus(code); ss('lp_land', code); vernieuw(); }
  };

  // ---- Productpagina: bestaande USP-regel laten rekenen via dit centrale bestand ----
  if (D.product) {
    window.getDeliveryData = function () {
      var lv = '';
      try {
        if (typeof getMetafieldData === 'function' && typeof getLampVormMetAantal === 'function') {
          var md = getMetafieldData();
          var aantal = typeof getAantal === 'function' ? getAantal() : 1;
          lv = getLampVormMetAantal(md.lampVorm, aantal) || '';
        }
      } catch (e) {}
      return window.LP_LEVERTIJD.productTekst(lv) || { text: '', tooltip: '' };
    };
    // 17-10-2026: aftellen tot de besteltijd live houden (gratis-verzendingregel en voorraadregel luisteren hiernaar)
    setInterval(function () { try { document.dispatchEvent(new CustomEvent('lp:levertijd-tik')); } catch (e) {} }, 30000);
    // Oude vaste tekst (oude templates) vervangen
    document.addEventListener('DOMContentLoaded', function () {
      var t = window.LP_LEVERTIJD.productTekst('');
      if (!t) return;
      document.querySelectorAll('span').forEach(function (s) {
        if (s.children.length === 0 && /^Levering binnen \d/.test(s.textContent.trim())) s.textContent = t.text;
      });
    });
  }

  // ---- Na ophalen van land/servertijd: teksten opnieuw zetten ----
  function vernieuw() {
    var el = document.querySelector('#productUSPs li .usp-text');
    if (el && D.product && typeof window.getDeliveryData === 'function') {
      var dd = window.getDeliveryData();
      if (el.firstChild && el.firstChild.nodeType === 3) el.firstChild.nodeValue = dd.text;
      var tt = el.querySelector('.tooltip-text');
      if (tt) tt.textContent = dd.tooltip;
    }
    try { document.dispatchEvent(new CustomEvent('lp:levertijd-update')); } catch (e) {}
  }
  var testTijd = params && params.get('lp_now');
  if (!TESTLAND && (!ss('lp_land') || !testTijd && ss('lp_offset') === null)) {
    fetch('/browsing_context_suggestions.json?_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) {
        var datum = res.headers.get('Date');
        if (datum && !testTijd) {
          var o = new Date(datum).getTime() - Date.now();
          if (!isNaN(o)) { ss('lp_offset', String(Math.abs(o) < 120000 ? 0 : o)); OFFSET = Math.abs(o) < 120000 ? 0 : o; }
        }
        return res.json();
      })
      .then(function (d) {
        var l = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (l) { ss('lp_land', l); if (!KEUS && !MARKTLAND) LAND = String(l).toUpperCase(); }
        if ((LAND && LAND !== 'NL') || OFFSET) {
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(vernieuw, 900); });
          else setTimeout(vernieuw, 900);
        }
      })
      .catch(function () {});
  }
})();
